<template>
  <button
    class="app-button"
    :title="title || ''"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <span><slot tag="span">Button</slot></span>
  </button>
</template>

<script>
@Component
class AppButton extends Vue {
  @Prop(String) title;
  @Prop(Boolean) disabled;
}

export default AppButton;
</script>

<style lang="scss" scoped>
@import 'vars';

button {
  cursor: pointer;
  position: relative;
  font-family: 'DayCare';
  padding: 0.5em 1em;
  font-size: 24px;
  // background: white;
  // background-color: #05d49b;
  // background: linear-gradient(rgb(24, 170, 255), rgb(29, 56, 255));
  background: linear-gradient(#00b8ff, #1d77ff);
  // background: linear-gradient(#18ffd4, #009cd8);
  border: none;
  // border: 6px solid white;
  border-radius: 2em;
  box-shadow: 0 3px 8px #00000052;
  transform: scale(1);
  overflow: hidden;
  transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);

  > span {
    // color: #0e89ff;
    color: white;
    display: inline-block;
    position: relative;
    transform-style: preserve-3d;
    transform: scale(1);
    transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);
    z-index: 1;
  }

  // &::after {
  //   content: '';
  //   opacity: 0;
  //   position: absolute;
  //   top: -5px;
  //   right: -5px;
  //   left: -5px;
  //   bottom: -5px;
  //   background-image: linear-gradient(#fb7636, #ff5795) !important;
  //   transition: 0.15s cubic-bezier(0.01, 0.85, 0.42, 1.73);
  // }

  @include hover {
    transform: scale(1.05);
    // background: transparent;
    // border: 3px solid transparent;
    box-shadow: 0 15px 40px rgba(0, 55, 78, 0.2);
    background-image: linear-gradient(#fb7636, #ff5795) !important;
    // border: 3px solid white;

    > span {
      color: #fff;
      transform: scale(1.15);
    }

    // &::after {
    //   opacity: 1;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppButton.vue